import {
  ConfirmationApproveReactivateIcon,
  SmileyFace,
  UnsuspendIcon,
} from "@/assets";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";

const Approval = () => {
  const [step, setStep] = useState(1);
  return (
    <div className="flex flex-col items-center justify-center gap-10 p-8">
      <div className="flex flex-col gap-9">
        <DialogHeader className="flex flex-col items-center text-center ">
          {step == 1 ? (
            <UnsuspendIcon />
          ) : (
            <ConfirmationApproveReactivateIcon />
          )}
          <div className="flex flex-col gap-2">
            <DialogTitle className="text-center text-green-3">
              {step == 1 ? "Approve User’s KYC?" : "User’s KYC Approved!"}
            </DialogTitle>
            <DialogDescription className="text-center">
              {step == 1
                ? "Are you sure you want to approve this user’s KYC?"
                : "You have successfully approved the KYC details of “Opeyemi Ojo”!"}
            </DialogDescription>
          </div>
        </DialogHeader>
        {step === 1 && (
          <div className="flex flex-col justify-around bg-off-white-1 gap-4 w-full rounded-[8px] py-5 px-4">
            <div className="flex items-center gap-2 ">
              <SmileyFace />

              <p className="text-base text-gray">
                Approving this KYC will cause;
              </p>
            </div>
            <ul className="gap-6 px-3 list-disc list-inside">
              <li className="text-xs text-gray-80">
                Lorem ipsum dolor sit amet, consectetur.
              </li>
              <li className="text-xs text-gray-80 ">
                Lorem ipsum dolor sit amet, consectetur.
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center w-full ">
        {step == 1 ? (
          <>
            <Button
              type="button"
              className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] w-full"
              onClick={() => setStep(2)}
            >
              Yes, I want to approve this KYC <ChevronRight />
            </Button>
            <DialogClose asChild>
              <Button type="button" variant="ghost">
                No, I want to cancel
              </Button>
            </DialogClose>
          </>
        ) : (
          <DialogClose asChild>
            <Link
              to="/dashboard/customers"
              className="flex justify-center items-center bg-off-white-2 h-12 rounded-[10px] w-full text-gray"
            >
              <ChevronLeft /> Back to dashboard
            </Link>
          </DialogClose>
        )}
      </div>
    </div>
  );
};

export default Approval;
